import Dexie from 'dexie';

const DB_NAME = 'vanguardians';
const DB_VERSION = 1;

const db = new Dexie(DB_NAME);
db.version(DB_VERSION).stores({
  settings: '',
  manifest: '',
  players: 'key'
});

export default db;